document.addEventListener('adev:cart:updated', (event) => {
    const cartData = event.detail;

    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
        cartDrawerEl.renderContents(cartData);

        if (cartDrawerEl.classList.contains('is-empty')) cartDrawerEl.classList.remove('is-empty');
    }
});

if (!customElements.get('adev-overlay')) {
    customElements.define('adev-overlay', class adevOverlay extends HTMLElement {
        constructor() {
            super();
        }

        close() {
            document.documentElement.classList.remove('is--overlay-on');

            document.dispatchEvent(new CustomEvent('adev:overlay:closed'));
        }

        connectedCallback() {
            this.addEventListener('click', this.close.bind(this));
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.close.bind(this));
        }

    });
}

if (!customElements.get('adev-drawer')) {
    customElements.define('adev-drawer', class adevDrawer extends HTMLElement {
        constructor() {
            super();

            this.closeEl = this.querySelector('[data-adev-drawer="close"]');

            document.addEventListener('adev:overlay:closed', () => {
                this.close();
            });
        }

        open() {
            this.classList.add('is--opened');
            document.documentElement.classList.add('is--overlay-on');
        }

        close() {
            this.classList.remove('is--opened');
            document.documentElement.classList.remove('is--overlay-on');
        }

        connectedCallback() {
            this.closeEl.addEventListener('click', this.close.bind(this));
        }

        disconnectedCallback() {
            this.closeEl.removeEventListener('click', this.close.bind(this));
        }

    });
}

if (!customElements.get('adev-product-card')) {
    customElements.define('adev-product-card', class adevProductCard extends HTMLElement {
        constructor() {
            super();
        }

        formatMoney(t,e){
            function n(t,e){return void 0===t?e:t}function o(t,e,o,i){if(e=n(e,2),o=n(o,","),i=n(i,"."),isNaN(t)||null==t)return 0;var r=(t=(t/100).toFixed(e)).split(".");return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+o)+(r[1]?i+r[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var i="",r=/\{\{\s*(\w+)\s*\}\}/,a=e||window.adev_theme.moneyFormat;switch(a.match(r)[1]){case"amount":i=o(t,2);break;case"amount_no_decimals":i=o(t,0);break;case"amount_with_comma_separator":i=o(t,2,".",",");break;case"amount_with_space_separator":i=o(t,2," ",",");break;case"amount_with_period_and_space_separator":i=o(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":i=o(t,0,".",",");break;case"amount_no_decimals_with_space_separator":i=o(t,0," ");break;case"amount_with_apostrophe_separator":i=o(t,2,"'",".")}return a.replace(r,i)
        }

        setCurrentVariant(){
            const checkedInputs = this.querySelectorAll('[data-adev-product-card="variant-option-value"]:checked');

            if (checkedInputs.length > 0) {
                this.variantOptions = Array.from(checkedInputs).map(input => {
                    return input.value;
                });

                this.currentVariant = this.variantsData.find((variant) => {
                    return !variant.options.map((option, index) => {
                        return this.variantOptions[index] === option
                    })
                    .includes(false);
                });
            } else {
                this.currentVariant = this.variantsData[0];
            }
        }

        initMediaCarousel(){
            this.mainCarouselEl = this.querySelector('[data-adev-product-card="media-list"]');
            if (!this.mainCarouselEl) return;

            this._mainSlider = new Flickity(this.mainCarouselEl, {
                cellAlign: 'left',
                draggable: false,
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                adaptiveHeight: false,
                initialIndex: parseInt(this.mainCarouselEl.dataset.initialIndex, 10) || 0
            });
        }

        destroyMediaCarousel(){
            if (this._mainSlider) {
                this._mainSlider.destroy();
                this._mainSlider = null;
            }
        }

        updateCurrentMedia(index){
            if (this._mainSlider) {
                this._mainSlider.select(index);
            }
        }

        initVariantsPicker(){
            this.querySelectorAll('[data-adev-product-card="variant-option"]').forEach(option => {

                this.querySelectorAll('[data-adev-product-card="variant-option-value"]').forEach(input => {
                    input.addEventListener('change', () => {
                        this.refresh();

                        const title = this.querySelector('[data-adev-product-card="product-title"]');
                        if (title && this.currentVariant) {
                            const url = new URL(title.getAttribute('href'), window.location.origin);
                            url.searchParams.set('variant', this.currentVariant.id);
                            
                            title.setAttribute('href', url.toString());
                            this.addToCartEl.setAttribute('href', url.toString());
                            title.innerHTML = input.dataset.title;
                        }
                    })
                });

            });
        }

        updatePrice(){
            this.salePriceEl.innerHTML = this.formatMoney(this.currentVariant.price);

            if (this.currentVariant.compare_at_price > this.currentVariant.price) {
                const strike = document.createElement('s');
                strike.innerHTML = this.formatMoney(this.currentVariant.compare_at_price);

                this.wasPriceEl.innerHTML = strike.outerHTML;
            } else {
                this.wasPriceEl.innerHTML = '';
            }
        }

        updateVariantStatuses(){
            const selectedOptionOneVariants = this.variantsData.filter(variant => {
                const firstCheckedInput = this.querySelector('[data-adev-product-card="variant-option-value"]:checked');
				return firstCheckedInput && firstCheckedInput.value === variant.option1
			});

			const options = this.querySelectorAll('[data-adev-product-card="variant-option"]')
			options.forEach((option, index) => {
				if(index === 0) {
					return;
				}

				const previousOptionSelected = options[index - 1].querySelector(':checked').value;

				const availableOptionInputsValue = selectedOptionOneVariants
					.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected)
					.map(variant => variant[`option${ index + 1 }`]);

				const optionInputs = option.querySelectorAll('[data-adev-product-card="variant-option-value"]');

				optionInputs.forEach(input => {
					if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
						input.classList.remove('is--disabled');
					} else {
						input.classList.add('is--disabled');
					}
				});

			});
        }

        updateAddToCart(){
            if (this.currentVariant && this.currentVariant.available) {
                this.addToCartEl.classList.remove('is--disabled');
            } else {
                this.addToCartEl.classList.add('is--disabled');
            }
        }

        updateMedia(){
            if (!this.currentVariant) return;

            if(this.currentVariant.featured_image !== null) {
                const mediaID = this.currentVariant.featured_media.id;
                
                const mediaItem = this.querySelector(`[data-adev-product-card="media-item"][data-media-id="${mediaID}"]`);
                if(mediaItem){
                    const index = parseInt(mediaItem.dataset.index, 10);
                    this.updateCurrentMedia(index);
                }
                
            }
        }

        refresh(){
            this.setCurrentVariant();
            this.updateMedia();
            this.updatePrice();
            this.updateVariantStatuses();
            this.updateAddToCart();
        }

        initAddToCart(){
            this.addToCartEl.addEventListener('click', (e) => {
                e.preventDefault();

                this.addToCartEl.classList.add('is--loading');

                const formData = new FormData();
                formData.append('id', this.currentVariant.id);
                formData.append('quantity', 1);
                formData.append('sections', 'cart-drawer,cart-icon-bubble');

                fetch(window.routes.cart_add_url + '.js', {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    this.addToCartEl.classList.remove('is--loading');
                    document.dispatchEvent(new CustomEvent('adev:cart:updated', { detail: data }));
                })
                .catch((error) => {
                    this.addToCartEl.classList.remove('is--loading');
                    console.error('Error:', error);
                });

            });
        }

        connectedCallback() {
            const jsonEl = this.querySelector('script[data-adev-product-card="json"]');
            this.variantsData = JSON.parse(jsonEl.textContent);

            this.salePriceEl = this.querySelector('[data-adev-product-card="current-price"]');
            this.wasPriceEl = this.querySelector('[data-adev-product-card="regular-price"]');

            this.addToCartEl = this.querySelector('[data-adev-product-card="add-to-cart"]');

            this.initMediaCarousel();

            this.setCurrentVariant();

            this.initVariantsPicker();

            this.initAddToCart();
        }

        disconnectedCallback() {
            
        }

    });
}

if (!customElements.get('adev-video-tag')) {
	customElements.define('adev-video-tag', class adevVideoTag extends HTMLElement {
		constructor() {
			super();

			this.autoplay = this.hasAttribute('data-autoplay') && this.getAttribute('data-autoplay') === 'true';

			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						if(this.autoplay) {
							this.togglePlay();
						} else {
							this.initVideo();
						}

						observer.unobserve(this);
					}
				});
			});

			observer.observe(this);
			
		}

		initVideo(){
			this.video = this.querySelector('video');

			if(!this.video) {
				const scriptEl = this.querySelector('script');

				this.innerHTML += scriptEl.innerHTML;
				this.video = this.querySelector('video');

				this.setVideoEventListeners();
			}
		}

		togglePlay(){
			this.initVideo();

			if (this.video.paused) {
				this.video.play();
			} else {
				this.video.pause();
			}
		}

		play(){
			this.initVideo();
			this.video.play();
		}

		pause(){
			this.initVideo();
			this.video.pause();
		}

		mute(){
			this.initVideo();
			this.video.muted = true;
		}

		unmute(){
			this.initVideo();
			this.video.muted = false;
		}

		toggleMute() {
			this.initVideo();

			if (this.video.muted) {
				this.video.muted = false;
			} else {
				this.video.muted = true;
			}
		}

		setVideoEventListeners(){
			this._onVideoMuted();

			this.video.addEventListener('play', this._onVideoPlay.bind(this));
			this.video.addEventListener('pause', this._onVideoPause.bind(this));
			this.video.addEventListener('volumechange', this._onVideoMuted.bind(this));

			const playButton = this.querySelector('[data-adev-video-tag="play"]');
			playButton.addEventListener('click', this.togglePlay.bind(this));

			const toggleMuteButton = this.querySelector('[data-adev-video-tag="mute"]');
			toggleMuteButton.addEventListener('click', this.toggleMute.bind(this));

			this.addEventListener('touchstart', () => this._handleTouchStart());
			this.addEventListener('touchend', () => this._handleTouchEnd());
		}

		_onVideoPlay() {
			this.classList.add('adev--is-revealed');
			this.classList.add('adev--is-playing');
		}

		_onVideoPause() {
			this.classList.remove('adev--is-playing');
		}

		_onVideoMuted() {
			if (this.video.muted) {
				this.classList.add('adev--is-muted');
			} else {
				this.classList.remove('adev--is-muted');
			}
		}

		_handleTouchStart() {
			this.classList.add('adev--is-touching');
			clearTimeout(this._handleTouchStartTimeout);
		}

		_handleTouchEnd() {
			this._handleTouchStartTimeout = setTimeout(() => {
				this.classList.remove('adev--is-touching');
			}, 1000);
		}

		connectedCallback() {
		}

		disconnectedCallback() {
			const playButton = this.querySelector('[data-adev-video-tag="play"]');
			playButton.removeEventListener('click', this.togglePlay.bind(this));

			const toggleMuteButton = this.querySelector('[data-adev-video-tag="mute"]');
			toggleMuteButton.removeEventListener('click', this.toggleMute.bind(this));

			if (this.video) {
				this.video.removeEventListener('play', this._onVideoPlay.bind(this));
				this.video.removeEventListener('pause', this._onVideoPause.bind(this));
				this.video.removeEventListener('volumechange', this._onVideoMuted.bind(this));
			}

			this.removeEventListener('touchstart', () => this._handleTouchStart());
			this.removeEventListener('touchend', () => this._handleTouchEnd());
		}

	});
}

if (!customElements.get('adev-quantity-selector')) {
    customElements.define('adev-quantity-selector', class adevQuantitySelector extends HTMLElement {
        constructor() {
            super();

            this.quantitySelectorInput = this.querySelector('input[data-adev-quantity-selector="input"]');
            this.decreaseButton = this.querySelector('[data-adev-quantity-selector="decrease"]');
            this.increaseButton = this.querySelector('[data-adev-quantity-selector="increase"]');
        }

        getValue() {
            return parseInt(this.quantitySelectorInput.value, 10);
        }

        connectedCallback() {
            this.decreaseButton.addEventListener('click', this.decreaseQuantity.bind(this));
            this.increaseButton.addEventListener('click', this.increaseQuantity.bind(this));
        }

        decreaseQuantity() {
            const currentValue = parseInt(this.quantitySelectorInput.value, 10);
            this.quantitySelectorInput.value = Math.max(1, currentValue - 1);
            this.dispatchEvent(new Event('change'));
        }

        increaseQuantity() {
            const currentValue = parseInt(this.quantitySelectorInput.value, 10);
            this.quantitySelectorInput.value = currentValue + 1;
            this.dispatchEvent(new Event('change'));
        }

        disconnectedCallback() {
            this.decreaseButton.removeEventListener('click', this.decreaseQuantity.bind(this));
            this.increaseButton.removeEventListener('click', this.increaseQuantity.bind(this));
        }

    });
}